import { Alert, Button, Space, Tag } from 'antd';
import styled from 'styled-components';
import { type IAsyncServiceOutputsDiff } from './compareAsyncServiceOutputs.ts';

const DiffItemList = styled.ul`
  margin: 4px 0 8px;
  padding-left: 16px;
  line-height: 1.8;
`;

export interface IStaleServiceOutputsAlertProps {
  diff: IAsyncServiceOutputsDiff;
  onUpdate: () => void;
}

/**
 * Componente per visualizzare un alert quando i campi di output di un servizio asincrono sono "stale".
 */
export function StaleServiceOutputsAlert(
  props: IStaleServiceOutputsAlertProps,
) {
  const { diff, onUpdate } = props;

  if (!diff.isStale) return null;

  return (
    <Alert
      type="warning"
      showIcon
      style={{ marginTop: 8, marginBottom: 8 }}
      message="Struttura servizio modificata"
      description={
        <Space direction="vertical" size={8}>
          <DiffItemList>
            {diff.added.length > 0 && (
              <li>
                <strong>Aggiunti:</strong>{' '}
                {diff.added.map(p => (
                  <Tag key={p.name}>{p.sourcePath ?? p.name}</Tag>
                ))}
              </li>
            )}
            {diff.removed.length > 0 && (
              <li>
                <strong>Rimossi:</strong>{' '}
                {diff.removed.map(p => (
                  <Tag key={p.name}>{p.sourcePath ?? p.name}</Tag>
                ))}
              </li>
            )}
            {diff.changed.length > 0 && (
              <li>
                <strong>Modificati:</strong>{' '}
                {diff.changed.map(c => (
                  <Tag key={c.current.name}>
                    {c.current.sourcePath ?? c.current.name}
                  </Tag>
                ))}
              </li>
            )}
          </DiffItemList>
          <Button size="small" type="primary" onClick={onUpdate}>
            Aggiorna
          </Button>
        </Space>
      }
    />
  );
}
